module.exports = __webpack_public_path__ + "static/media/icon_help.beff4fdc.svg";